/**
 * @fileoverview Input/output schemas for world-system-ideation-v3.
 *
 * This agent generates ideas for world systems (magic systems, natural laws, social customs, technologies, materials).
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldSystemIdeaV3Schema, WorldSystemElementEnum } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldSystems.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
  targetElement: WorldSystemElementEnum.optional().describe(
    'Optional filter to generate only a specific element type (magic-system, natural-law, social-custom, technology, or material). If not provided, generates a mix.'
  ),
});

export type Input = z.infer<typeof InputSchema>;

const WorldSystemIdeaOutputSchema = WorldSystemIdeaV3Schema.omit({
  tempId: true,
  source: true,
});

export const OutputSchema = z.object({
  systems: z.array(WorldSystemIdeaOutputSchema).describe('An array of generated world system ideas.'),
});

export type Output = z.infer<typeof OutputSchema>;
